import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const SaleDetail = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState({
        CompanyId: '',
        InvoiceDate: '',
        InvoiceTime: '',
        InvoiceNumber: '',
        TableId: '',
        KOTId: '',
        Amount: '',
        DiscountAmount: '',
        DiscountPer: '',
        NetAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        RoundOff: '',
        TotalAmount: '',
        PaymentType: '',
        FinYear: '',
        isSubmit: false,
        TableText: '',
        ModifiedBy: userId,
        PreviousTotalAmount: '',
    });
    const [itemdata, setData] = useState([]);


    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };
    const formatTimeForInput = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);
        const hours = time.getHours().toString().padStart(2, '0');
        const minutes = time.getMinutes().toString().padStart(2, '0');
        const seconds = time.getSeconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    };

    useEffect(() => {
        fetchData('SaleApi', `/SaleDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setData(response.response_data.SaleDetails);
                }

                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));

            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);





    return (
        <Fragment>

            <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                        
                    `}
                </style>


                <div>
                    <div className="w-full mb-2 flex">
                        <h5 className="productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> SALE - DETAILS</h5>

                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/SaleEditDetails"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            BACK TO LIST
                        </Button>
                    </div>
                </div>

                <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-5px' }}>
                    <div className="w-full mb-4 flex">

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.InvoiceNumber}
                                type="text"
                                placeholder="Enter Invoice No"
                                disabled
                                style={{ height: '35px' }}
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.InvoiceDate)}
                                type="date"
                                placeholder="Enter Invoice Date"
                                disabled
                                style={{ height: '35px' }}
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice Time
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatTimeForInput(formData.InvoiceTime)}
                                type="Time"
                                placeholder="Enter Invoice Time"
                                disabled
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Table Name
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-left h-8"
                                value={formData.TableText}
                                type="text"
                                placeholder="Table Name"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />

                        </div>

                    </div>
                    <div className="w-full mb-4 flex" style={{ marginTop: '-1.50%' }}>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.Amount).toFixed(2)}
                                type="number"
                                placeholder="Enter Amount"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Discount %
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.DiscountPer).toFixed(2)}
                                name='DiscountPer'
                                type="number"
                                placeholder="Enter Discount %"
                                style={{ fontWeight: 'bold' }}
                                disabled
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Discount Amt
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.DiscountAmount).toFixed(2)}
                                name='DiscountAmount'
                                type="number"
                                placeholder="Enter Discount Amount"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Addt'l. Discount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.AdditionalDiscount).toFixed(2)}
                                name='AdditionalDiscount'
                                type="number"
                                placeholder="Enter Additional Discount"
                                style={{ fontWeight: 'bold' }}
                                disabled
                            />
                        </div>


                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Net Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.NetAmount).toFixed(2)}
                                name='NetAmount'
                                type="number"
                                placeholder="Enter Net Amount"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                CGST
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.CGSTAmount).toFixed(2)}
                                name='CGSTAmount'
                                type="number"
                                placeholder="Enter CSGT"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                SGST
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.SGSTAmount).toFixed(2)}
                                name='SGSTAmount'
                                type="number"
                                placeholder="Enter SGST"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                IGST
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.IGSTAmount).toFixed(2)}
                                name='IGSTAmount'
                                type="number"
                                placeholder="Enter IGST"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-4 flex" style={{ marginTop: '-1.30%' }}>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Packing Charge
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.PackingCharge).toFixed(2)}
                                type="number"
                                placeholder="Enter Packing Charge"
                                name='PackingCharge'
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Round Off
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.RoundOff).toFixed(2)}
                                type="number"
                                placeholder="Enter Round Off"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Total Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.TotalAmount).toFixed(2)}
                                type="number"
                                placeholder="Enter Total Amount"
                                disabled
                                style={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Cash
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.CashAmount).toFixed(2)}
                                type="number"
                                placeholder="Enter Cash Amount"
                                name='CashAmount'
                                style={{ fontWeight: 'bold', color: 'red' }}
                                disabled
                            />
                        </div>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Card
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.CardAmount).toFixed(2)}
                                type="number"
                                placeholder="Enter Card Amount"
                                name='CardAmount'
                                style={{ fontWeight: 'bold', color: 'red' }}
                                disabled
                            />
                        </div>

                        <div className="w-1/7 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                UPI
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                value={Number(formData.UPIAmount).toFixed(2)}
                                type="number"
                                placeholder="Enter UPI Amount"
                                name='UPIAmount'
                                style={{ fontWeight: 'bold', color: 'red' }}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="w-full mb-4 flex" style={{ marginTop: '5.50px' }}>
                        <div className="w-full mb-4 flex">
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '4px' }}>Item Name</th>
                                            <th style={{ padding: '4px', textAlign: 'center' }}>Quantity</th>
                                            <th style={{ padding: '4px', textAlign: 'center' }}>Rate</th>
                                            <th style={{ padding: '4px', textAlign: 'center' }}>Disc %</th>
                                            <th style={{ padding: '4px', textAlign: 'center' }}>Total</th>                                            
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {itemdata.map((invdetail, index) => (
                                            <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '60%' }}>{invdetail.ItemName}</td>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center', backgroundColor: invdetail.Quantity > invdetail.BalStock ? '#ffcccc' : 'inherit' }}>
                                                    <input
                                                        type="number"
                                                        value={invdetail.Quantity}
                                                        onChange={(e) => handleCalculation(e, index)}
                                                        style={{ maxWidth: '120px', textAlign: 'right', height: '30px', fontWeight: 'bold' }}
                                                        name="Quantity"
                                                        readOnly
                                                    />
                                                </td>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center', fontWeight: 'bold' }}>{invdetail.Rate}</td>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center', fontWeight: 'bold' }}>{invdetail.DiscountPer}</td>
                                                <td style={{ padding: '4px', fontSize: '14px', width: '10%', textAlign: 'center', fontWeight: 'bold' }}>
                                                    {typeof invdetail.TotalAmount === 'number' ? invdetail.TotalAmount.toFixed(2) : invdetail.TotalAmount}
                                                </td>
                                                
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </TableContainer>
                        </div>
                    </div>

                </div >                

            </div>
        </Fragment >
    );

};

export default SaleDetail;
